<template>
  <div class="btn-blue">
    <a :href="url">
      <mdicon name="NewspaperVariantMultipleOutline" class="flex justify-center text-white" size="90" />
      <h2 class=" text-white text-2xl text-center font-semibold mb-4">{{ title }}</h2>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: 'https://duquedecaxias.rj.gov.br/noticias/1'
    }
  },
  props: {
    title: String
  },
}
</script>
